import { RestSlice } from '../../../../../redux/rest.slice';
import { IppDataSourceMonitoringPoint } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const ippMonitoringPointSlice = new RestSlice<IppDataSourceMonitoringPoint>(
	localizationService.getLocalizedString('ipp.industryAccount.dataProviders.translations.monitoringPoints.heading'),
	Resource.IppDataSourceMonitoringPoint
);
export default ippMonitoringPointSlice.rests.reducer;
